// extracted by mini-css-extract-plugin
export default {"imprint":"ContactPage_imprint__lz-p8","imprintButton":"ContactPage_imprintButton__QGgnO","logo":"ContactPage_logo__p3JTJ"};